// The formatters that do NOT depend on the user's language, kept apart from the
// ones that do.
//
// Not a stylistic split. The service worker needs `formatPhone` for notification
// titles, and importing it from `format.ts` dragged in `$lib/i18n/index.svelte`
// — a module built on Svelte runes. Runes are compiled away for the app bundle
// but not for the worker's own build pass, so the worker shipped a bare `$state`
// call, threw `ReferenceError: $state is not defined` on evaluation, and never
// registered at all. No worker means no precache, which means the installed app
// falls through to the network and shows the browser's offline page.
//
// Anything the worker imports must stay on this side of the line: no runes, no
// `document`, no `window`.

/** Loose digit grouping for display; the stored value stays strict E.164. */
export function formatPhone(e164: string): string {
  const digits = e164.replace(/^\+/, '');
  const groups: string[] = [];
  for (let i = digits.length; i > 0; i -= 3) {
    groups.unshift(digits.slice(Math.max(0, i - 3), i));
  }
  return `+${groups.join(' ')}`;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
}
